import type { ModelsContent } from "../types";
import { renderSectionHeader } from "./section-header";

export function renderModels(models: ModelsContent): string {
  const { labels } = models;
  const cards = models.items
    .map(
      (m, i) => `
      <article class="model${m.featured ? " featured" : ""}" data-reveal style="--i:${i}">
        ${m.featured ? `<span class="model-flag">${labels.featured}</span>` : ""}
        <div class="model-top">
          <h3>${m.name}</h3>
          <span class="model-tagline">${m.tagline}</span>
        </div>
        <dl class="model-specs">
          <div><dt>${labels.params}</dt><dd>${m.params}</dd></div>
          <div><dt>${labels.context}</dt><dd>${m.context}</dd></div>
        </dl>
        <p class="model-desc">${m.description}</p>
        <ul class="model-tags">
          ${m.tags.map((t) => `<li>${t}</li>`).join("")}
        </ul>
      </article>`,
    )
    .join("");

  return `
    <section class="section" id="${models.id}">
      ${renderSectionHeader(models.header)}
      <div class="models${models.items.length === 1 ? " models--single" : ""}">${cards}</div>
    </section>`;
}
